import { useInfiniteQuery, useMutation, useQueryClient } from '@tanstack/react-query'
import { reviewsApi } from '@/api/reviews'

const keys = {
  moderation: ['reviews', 'moderation'] as const,
}

export function useModerationReviews() {
  return useInfiniteQuery({
    queryKey: keys.moderation,
    queryFn: ({ pageParam }: { pageParam: string | undefined }) => reviewsApi.moderationList(pageParam),
    initialPageParam: undefined as string | undefined,
    getNextPageParam: (lastPage) => (lastPage.hasMore ? (lastPage.nextCursor ?? undefined) : undefined),
  })
}

export function useSetReviewHidden() {
  const qc = useQueryClient()
  return useMutation({
    mutationFn: ({ id, hidden }: { id: string; hidden: boolean }) => reviewsApi.setHidden(id, hidden),
    onSuccess: () => qc.invalidateQueries({ queryKey: keys.moderation }),
  })
}

export function usePublishReviewReply() {
  const qc = useQueryClient()
  return useMutation({
    mutationFn: ({ id, reply }: { id: string; reply: string }) => reviewsApi.publishReply(id, reply),
    onSuccess: () => qc.invalidateQueries({ queryKey: keys.moderation }),
  })
}
